import { getSizeFieldsForCategory } from "./categoryFormConfig";
import { sumSizeStock } from "../../../Routes/Marketplace/libs/productSizes";

export const LOW_STOCK_THRESHOLD = 5;

export const getMerchantProductStock = (product) => {
  const sizeFields = getSizeFieldsForCategory(product?.category);
  if (sizeFields.length) return sumSizeStock(product, sizeFields);
  return Math.max(0, parseInt(product?.quantity, 10) || 0);
};

export const isLowStock = (product) => getMerchantProductStock(product) <= LOW_STOCK_THRESHOLD;

export const isOutOfStock = (product) => getMerchantProductStock(product) <= 0;
